import { useAnalytics } from "@codat/analytics";
import { Modal as OrchardModal } from "@codat/orchard-ui";
import { ModalProps } from "@codat/orchard-ui/dist/es/components/Modal/Modal";
import * as React from "react";

interface ModalWithTrackingProps extends ModalProps {
  eventProperties?: Record<string, unknown>;
}

const Modal = ({
  onClose,
  eventProperties,
  ...props
}: React.PropsWithChildren<ModalWithTrackingProps>) => {
  const { sendEvent } = useAnalytics();

  const handleOnClose = () => {
    sendEvent("Close", eventProperties);
    if (onClose) {
      onClose();
    }
  };

  return (
    <OrchardModal onClose={handleOnClose} {...props}>
      {props.children}
    </OrchardModal>
  );
};

Modal.Header = OrchardModal.Header;
Modal.Body = OrchardModal.Body;
Modal.Footer = OrchardModal.Footer;
Modal.Section = OrchardModal.Section;

export default Modal;
